
import { EQLSearch, GraphQLSearchVariables } from "@eco/client";
import { SetUrlParamsCallback, TUrlFilter, useUrlParamsState } from "hooks";
import { useCallback, useMemo } from "react"
import { SetterOrUpdater } from "recoil";
import { useDataGridFilterGlobalState } from "./useDataGridFilterGlobalState";

/**
 * Hooks that retrive filter value of data grid
 * 
 * @param id Id of the DataGrid component
 * @param isUrlParamsState flag telling if this hooks should use Url Params as filter state
 * @param defaultValue the initial value of state (It's not recommended to initialize it here, it's the DataGrid purpose)
 * @returns 
 */
export const useDataGridFilterState = (id: string, isUrlParamsState: boolean = true, defaultValue?: TDataGridSortFilter) => {

    const { urlParams, setUrlParams } = useUrlParamsState<TDataGridSortFilter>(defaultValue)
    const { value: globalFilterValue, setValue: setGlobalFilterValue } = useDataGridFilterGlobalState(id, defaultValue)

    const filter = useMemo(() => {
        if (isUrlParamsState) {
            return urlParams
        }

        return globalFilterValue
    }, [globalFilterValue, urlParams])

    const setFilter = useCallback((key: string | SetUrlParamsCallback<TDataGridSortFilter> | SetterOrUpdater<TDataGridSortFilter>, value?: any) => {
        if (isUrlParamsState) {
            if (typeof key === 'string') {
                return setUrlParams(key, value)
            }
            return setUrlParams(key as SetUrlParamsCallback<TDataGridSortFilter>)
        }

        if (typeof key === 'string') {
            return setGlobalFilterValue(key, value)
        }

        return setGlobalFilterValue(key)
    }, [isUrlParamsState, setUrlParams, setGlobalFilterValue])

    return {
        filter,
        setFilter
    }
}

export type TSortFilter = TUrlFilter & {
    sort?: GraphQLSearchVariables['sort'] | EQLSearch['sort'] | null
    orderBy?: string | null
    pageSize?: number | null
    page?: number
}

export type TDataGridSortFilter = TSortFilter 
